import React from "react";
import { Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar from "../Sidebar/Sidebar";
import { adminLayoutRoute } from "../../Routes/Routes";
import AdminSessionGate from "./AdminSessionGate";
const AdminLayout = () => {
  return (
    <AdminSessionGate>
    <Box sx={{ display: "flex", height: "100vh" }}>
      <Routes>
        {adminLayoutRoute?.map((route, index) => {
          return (
            <Route
              key={index}
              exact={route.exact}
              path={route.path}
              element={
                route.sidebar ? (
                  <>
                    <Sidebar />
                    <Box
                      sx={{
                        width: {
                          xs: "100%",
                          md: "calc(100% - 240px)",
                        },
                        height: "100vh",
                        overflow: "auto",
                        p: 1,
                        bgcolor: "background.default", // Usa o background do tema (dark mode)
                      }}
                    >
                      {route.component}
                    </Box>
                  </>
                ) : (
                  <Box
                    sx={{ 
                      width: "100%", 
                      height: "100vh", 
                      overflow: "auto",
                      bgcolor: "background.default", // Usa o background do tema (dark mode)
                    }}
                  >
                    {route.component}
                  </Box>
                )
              }
            />
          );
        })}
      </Routes>
    </Box>
    </AdminSessionGate>
  );
};
export default AdminLayout;
